export default __webpack_public_path__ + "static/media/theMayor.0c294bc1.png";